import React from "react";

//CSS
import "./warehouseCard.css";

//Animations
import { motion } from "framer-motion";
import { RevealVariants } from "../Other Components/anims";

function WarehouseCard({
  Name,
  ID,
  Address,
  imgSrc,
  onClick,
  disabled,
  className,
}) {
  return (
    <motion.div
      initial="hiddenFade"
      whileInView="shownFast"
      whileHover={"hover"}
      onClick={!disabled ? onClick : undefined}
      viewport={{ once: RevealVariants.showOnce }}
      variants={RevealVariants}
      className={
        (disabled ? "warehouse-card disabled" : "warehouse-card") +
        " " +
        className
      }
    >
      <div className="warehouse-card-image-container">
        <img className="warehouse-card-image" src={imgSrc} alt="No image." />
      </div>
      <div className="warehouse-card-info">
        <p className="warehouse-card-text name">{Name}</p>
        <div className="warehouse-card-details">
          <p className="warehouse-card-text id">ID: {ID}</p>
          <p className="warehouse-card-text address">Address: {Address}</p>
        </div>
      </div>
    </motion.div>
  );
}

export default WarehouseCard;
